import React from 'react'
import { Stack } from '@/components/shared/atoms/layout/Stack'
import { CardShell } from '@/components/frontend/atoms/content/CardShell'
import { CardBody } from '@/components/frontend/atoms/content/CardBody'
import { IconBox, type IconName } from '@/components/frontend/atoms/content/IconBox'
import { CheckItem } from '@/components/frontend/atoms/content/CheckItem'
import { Heading } from '@/components/frontend/atoms/typography/Heading'
import { Text } from '@/components/frontend/atoms/typography/Text'

interface ServiceCardProps {
  icon: IconName
  title: string
  description: string
  points: string[]
}

export const ServiceCard: React.FC<ServiceCardProps> = ({ icon, title, description, points }) => (
  <CardShell variant="interactive">
    <CardBody>
      <Stack gap="4">
        <IconBox icon={icon} />
        <Stack gap="2">
          <Heading level="4" as="h3">{title}</Heading>
          <Text size="sm" tone="muted">{description}</Text>
        </Stack>
        <Stack gap="2">
          {points.map((point) => <CheckItem key={point}>{point}</CheckItem>)}
        </Stack>
      </Stack>
    </CardBody>
  </CardShell>
)
